module.exports = __webpack_public_path__ + "static/img/blo.9debc9ad.png";